import { createSlice } from '@reduxjs/toolkit';
import { getShipping } from './ShippingApi';
import { getFormattedValidationErrorFromAction } from 'Utils/getFormattedValidationErrorFromAction';

const initialState = {
  isLoading: false,
  data: {},
  error: null,
  errorAddressCheckout: false,
  errorPhoneNumber: false,
  cart:{
    total:0,
  }
};

const shippingSlice = createSlice({
  name: 'shippingSlice',
  initialState,
  reducers: {
    resetShipping: (state) => {
      state.data = {};
      state.error = null;
    },
    setErrorMessage: (state, action) => {
      state.error = action.payload;
    },
    setErrorCheckout: (state, action) => {
      state.errorAddressCheckout = action.payload;
    },
    setErrorPhoneNumber: (state, action) => {
      state.errorPhoneNumber = action.payload;
    },
    setTotalCart: (state, action) => {
      state.cart.total = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getShipping.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getShipping.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;
        state.data = action.payload;
      })
      .addCase(getShipping.rejected, (state, action) => {
        state.data = {};

        state.isLoading = false;
        const formattedError = getFormattedValidationErrorFromAction({
          error: {
            response: action.payload.response,
          },
        });

        const formattedMessage = formattedError?.subMessage;

        if (formattedError.subs[0] && formattedError.subs[0].message) {
          state.error =
            formattedMessage ===
              'Falha no cep passado - Não está cadastrado na base' ||
            formattedMessage.toLowerCase().includes('cep não encontrado') ||
            formattedMessage.toLowerCase() === 'entrega indisponivel'
              ? 'CEP inválido ou produto indisponível para a sua região.'
              : formattedMessage;
        } else {
          state.error =
            'CEP inválido ou produto indisponível para a sua região.';
        }
      });
  },
});

export const {
  resetShipping,
  setErrorMessage,
  setErrorCheckout,
  setErrorPhoneNumber,
  setTotalCart,
} = shippingSlice.actions;

export default shippingSlice.reducer;
